<template>
  <div>
    <div class="flex justify-content-end items-center">
      <template v-if="false">
        <div class="text-black fs-14 mr-3 cursor-pointer fw-600" :class="{
          'pointer-events-none': isSyncing,
        }" @click="handleSyncVimes()">
          <span class="align-middle mr-2">
            <i v-if="isSyncing" class="el-icon-loading text-lg" />
            <i v-else class="el-icon-refresh text-lg" />
          </span>
          <span class="align-middle">Đồng bộ dữ liệu Vimes</span>
        </div>
      </template>
      <div v-if="$route.query.tab === 'ChanDoanHinhAnh'" class="mr-4 cursor-pointer fs-14 fw-700 txt-grey-900"
        @click="handleOpenPacs()">
        <i class="el-icon-folder-opened fs-18" style="color: #03267a" />
        Dữ liệu PACS
      </div>
      <div class="mr-3 cursor-pointer fs-14 fw-700 txt-grey-900" @click="showModal(true, (checkType = 1))">
        <svg class="mr-1" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.039 5.13579L8.1 3.06528V11.6984C8.1 11.9372 8.19482 12.1662 8.3636 12.335C8.53239 12.5038 8.76131 12.5987 9 12.5987C9.23869 12.5987 9.46761 12.5038 9.6364 12.335C9.80518 12.1662 9.9 11.9372 9.9 11.6984V3.06528L11.961 5.13579C12.0447 5.22017 12.1442 5.28714 12.2539 5.33284C12.3636 5.37855 12.4812 5.40208 12.6 5.40208C12.7188 5.40208 12.8364 5.37855 12.9461 5.33284C13.0558 5.28714 13.1553 5.22017 13.239 5.13579C13.3234 5.05211 13.3903 4.95254 13.436 4.84284C13.4817 4.73314 13.5052 4.61547 13.5052 4.49663C13.5052 4.37779 13.4817 4.26013 13.436 4.15043C13.3903 4.04073 13.3234 3.94116 13.239 3.85747L9.639 0.256576C9.55341 0.174619 9.45248 0.110375 9.342 0.067529C9.12288 -0.0225097 8.87712 -0.0225097 8.658 0.067529C8.54752 0.110375 8.44659 0.174619 8.361 0.256576L4.761 3.85747C4.67709 3.94141 4.61052 4.04106 4.56511 4.15072C4.51969 4.26039 4.49632 4.37793 4.49632 4.49663C4.49632 4.61534 4.51969 4.73288 4.56511 4.84254C4.61052 4.95221 4.67709 5.05186 4.761 5.13579C4.84491 5.21973 4.94454 5.28631 5.05418 5.33173C5.16382 5.37716 5.28133 5.40054 5.4 5.40054C5.51867 5.40054 5.63618 5.37716 5.74582 5.33173C5.85546 5.28631 5.95509 5.21973 6.039 5.13579ZM17.1 8.99776C16.8613 8.99776 16.6324 9.0926 16.4636 9.26142C16.2948 9.43025 16.2 9.65922 16.2 9.89798V15.2993C16.2 15.5381 16.1052 15.7671 15.9364 15.9359C15.7676 16.1047 15.5387 16.1996 15.3 16.1996H2.7C2.4613 16.1996 2.23239 16.1047 2.0636 15.9359C1.89482 15.7671 1.8 15.5381 1.8 15.2993V9.89798C1.8 9.65922 1.70518 9.43025 1.5364 9.26142C1.36761 9.0926 1.13869 8.99776 0.9 8.99776C0.661305 8.99776 0.432387 9.0926 0.263604 9.26142C0.0948211 9.43025 0 9.65922 0 9.89798V15.2993C0 16.0156 0.284464 16.7025 0.790812 17.209C1.29716 17.7155 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.7155 17.2092 17.209C17.7155 16.7025 18 16.0156 18 15.2993V9.89798C18 9.65922 17.9052 9.43025 17.7364 9.26142C17.5676 9.0926 17.3387 8.99776 17.1 8.99776Z"
            fill="#03267A" />
        </svg>
        Upload Phiếu
      </div>
    </div>
    <div class="table-responsive handleLoading" v-loading="loadingList">
      <el-table :data="emrIndications" style="width: 100%" row-class-name="text-black text-sm cursor-pointer"
        header-cell-class-name="text-black text-base font-semibold" @row-click="viewDetail">
        <el-table-column class="border-bottom txt-grey-800 whitespace-nowrap fw-500 ml-md-2" label="Tên chỉ định">
          <template slot-scope="scope">
            <div class="flex flex-row items-center">
              <div class="cursor-pointer mr-2" @click.stop="subscribe(scope.row)">
                <svg v-if="scope.row.subscribed" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.666 13.782L16 13.186V8C16 6.93913 15.5786 5.92172 14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4C10.9391 4 9.92172 4.42143 9.17158 5.17157C8.42143 5.92172 8.00001 6.93913 8.00001 8V13.186L7.33401 13.782C6.36755 14.6445 5.65987 15.7586 5.29001 17H18.71C18.3401 15.7586 17.6325 14.6445 16.666 13.782ZM15 19C15 19.7956 14.6839 20.5587 14.1213 21.1213C13.5587 21.6839 12.7957 22 12 22C11.2044 22 10.4413 21.6839 9.87868 21.1213C9.31608 20.5587 9.00001 19.7956 9.00001 19H3.00001C2.99865 17.7335 3.26524 16.4811 3.78229 15.325C4.29933 14.1689 5.05512 13.1353 6.00001 12.292V8C6.00001 6.4087 6.63215 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8V12.292C18.9449 13.1353 19.7007 14.1689 20.2177 15.325C20.7348 16.4811 21.0014 17.7335 21 19H15ZM12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19H11C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20Z"
                    fill="#EE860B" />
                </svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.0001 19.5001C15.0001 20.2957 14.684 21.0588 14.1214 21.6214C13.5588 22.184 12.7958 22.5001 12.0001 22.5001C11.2045 22.5001 10.4414 22.184 9.87879 21.6214C9.31618 21.0588 9.00011 20.2957 9.00011 19.5001H6.65711L8.65711 17.5001H18.7101C18.3402 16.2587 17.6326 15.1445 16.6661 14.2821L16.0001 13.6861V10.1561L17.9901 8.16608C17.9971 8.27608 18.0001 8.38808 18.0001 8.50008V12.7921C18.945 13.6354 19.7008 14.669 20.2178 15.8251C20.7349 16.9812 21.0015 18.2336 21.0001 19.5001H15.0001ZM3.29511 17.2051C3.74509 15.5009 4.68568 13.9664 6.00011 12.7921V8.50008C5.99997 7.31329 6.35179 6.15311 7.01107 5.16628C7.67035 4.17946 8.60747 3.41031 9.70392 2.95613C10.8004 2.50194 12.0069 2.38312 13.1709 2.61469C14.3348 2.84626 15.404 3.41782 16.2431 4.25708L14.8281 5.67208C14.2687 5.11284 13.5561 4.73202 12.7802 4.57775C12.0044 4.42348 11.2003 4.50269 10.4695 4.80537C9.7387 5.10805 9.11404 5.62061 8.67451 6.27825C8.23497 6.93589 8.00028 7.70908 8.00011 8.50008V12.5001L3.29511 17.2051ZM12.0001 20.5001C12.2653 20.5001 12.5197 20.3947 12.7072 20.2072C12.8948 20.0197 13.0001 19.7653 13.0001 19.5001H11.0001C11.0001 19.7653 11.1055 20.0197 11.293 20.2072C11.4805 20.3947 11.7349 20.5001 12.0001 20.5001ZM21.0921 2.20708C21.2796 2.39461 21.3849 2.64892 21.3849 2.91408C21.3849 3.17925 21.2796 3.43355 21.0921 3.62108L4.12211 20.5911C4.02993 20.6867 3.91964 20.7629 3.79768 20.8154C3.67571 20.8679 3.54451 20.8956 3.41173 20.8968C3.27896 20.8981 3.14726 20.8729 3.02433 20.8227C2.9014 20.7725 2.7897 20.6983 2.69574 20.6045C2.60178 20.5106 2.52745 20.3991 2.47708 20.2762C2.42671 20.1533 2.40132 20.0217 2.40238 19.8889C2.40343 19.7561 2.43093 19.6249 2.48325 19.5028C2.53557 19.3808 2.61167 19.2704 2.70711 19.1781L19.6771 2.20808C19.77 2.11511 19.8803 2.04135 20.0017 1.99102C20.1231 1.9407 20.2532 1.91479 20.3846 1.91479C20.516 1.91479 20.6462 1.9407 20.7676 1.99102C20.889 2.04135 20.9992 2.11511 21.0921 2.20808V2.20708Z"
                    fill="#667085" />
                </svg>
              </div>
              <div class="d-block fs-14 pl-md-2">{{ scope.row.name }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column class="border-bottom txt-grey-800 whitespace-nowrap fw-500 ml-md-2" label="Ngày chỉ định">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.date
                  ? moment(scope.row.date).utc().format('HH:mm:ss DD/MM/YYYY')
                  : ''
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column class="border-bottom txt-grey-800 whitespace-nowrap fw-500 ml-md-2" label="Bác sĩ chỉ định">
          <template slot-scope="scope">
            <span class="fs-14">
              {{
                scope.row.indicator_name ||
                (scope.row.indicator && scope.row.indicator.name)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Khoa chỉ định">
          <template slot-scope="scope">
            <span class="fs-14">
              {{
                scope.row.indicator_ws_name ||
                (scope.row.indicator_w_s && scope.row.indicator_w_s.name)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Nhận xét" v-if="indType === 2">
          <template slot-scope="scope">
            <div class="v-html fs-14" v-html="scope.row.result ? scope.row.result.conclusion : ''"></div>
          </template>
        </el-table-column>
        <el-table-column label="Trạng thái" class="fs-14">
          <template slot-scope="scope">
            <span class="fs-14">{{
              !scope.row.status ? "Đang chờ KQ" : "Đã có KQ"
              }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex justify-content-end mt-3">
      <el-pagination v-if="emrIndicationPaging" background layout="prev, pager, next" :total="emrIndicationPaging.total"
        :page-size="parseInt(emrIndicationPaging.per_page)" @current-change="handleCurrentPage"></el-pagination>
    </div>

    <div class="modal fade" id="modalEmrIndicationView" tabindex="-1" role="dialog"
      aria-labelledby="modalEmrIndicationViewLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl" role="document">
        <div class="modal-content" v-loading="loadingDetail || loadingPrinting">
          <div class="d-flex justify-content-between p-3 pb-0">
            <div v-if="editingMode !== 'result' && editingMode !== 'view'" :class="editingMode === 'update'
              ? 'fs-24 fw-700 txt-grey-900 text-center w-100 ml-40'
              : 'fs-24 fw-700 txt-grey-900 text-center w-100 ml-16'
              ">
              CHI TIẾT CHỈ ĐỊNH
            </div>
            <button :disabled="loadingList" type="button" class="close bg-white border-0 ml-auto" data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true" class="fs-30 fw-500">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-0" v-if="editingInd">
            <div class="row mb-3">
              <div class="col-12">
                <div class="row mb-3">
                  <div class="col-md-4 flex align-items-end">
                    <div class="view-label">Tên chỉ định:</div>
                    <div class="fs-16 fw-700 txt-grey-900" v-if="editingMode === 'view' || editingMode === 'result'">
                      {{ editingInd.name }}
                    </div>
                    <el-input v-if="editingMode === 'update'" class="w-100" placeholder="Nhập Tên Chỉ Định"
                      v-model="formUpdate.name"></el-input>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4 flex align-items-center">
                    <div class="view-label">Ngày chỉ định:</div>
                    <div class="fs-16 fw-700 txt-grey-900" v-if="editingMode === 'view' || editingMode === 'result'">
                      {{
                        editingInd.date
                          ? moment(editingInd.date).utc().format(
                            "HH:mm:ss DD/MM/YYYY"
                          )
                          : ""
                      }}
                    </div>
                    <input v-if="editingMode === 'update'" type="datetime-local" v-model="formUpdate.date"
                      class="form-control fw-500 txt-grey-900" />
                  </div>
                  <div class="col-md-4 flex align-items-center">
                    <div class="view-label">Bác sĩ chỉ định:</div>
                    <div class="fs-16 fw-700 txt-grey-900" v-if="editingMode === 'view' || editingMode === 'result'">
                      {{
                        editingInd.indicator_name ||
                        (editingInd.indicator && editingInd.indicator.name)
                      }}
                    </div>
                    <el-select v-if="editingMode === 'update'" v-model="formUpdate.indicator_id" filterable allow-create
                      remote reserve-keyword placeholder="Tìm kiếm tên" class="w-100" :remote-method="getDoctor"
                      :loading="loadingDoctor">
                      <el-option v-for="item in doctors" :key="item.id + 'dtr2'" :label="item.name"
                        :value="item.user_id"></el-option>
                    </el-select>
                  </div>
                  <div class="col-md-4 flex align-items-center">
                    <div class="mr-3 pl-1">Khoa:</div>
                    <div class="fs-16 fw-700 txt-grey-900">
                      {{
                        editingInd.indicator_w_s &&
                        editingInd.indicator_w_s.name
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div :class="editingMode !== 'update' && editingInd.result && indType === 1
                ? `col-4`
                : `col-12`
                ">
                <template v-if="editingMode !== 'result'">
                  <div class="row mb-3" v-if="editingMode === 'update'">
                    <div class="flex">
                      <div class="col-md-4 flex align-items-center">
                        <div class="view-label">Tên file:</div>
                        <input readonly :value="!this.file
                          ? getFilename(formUpdate.pdf_url)
                          : getFilename(this.file.name)
                          " v-if="editingMode === 'update'" class="form-control fw-500 txt-grey-900" />
                      </div>
                      <button :disabled="loadingList" @click="onShowPickFileUpdate" type="button"
                        class="btn bg-pri text-white ml-2">
                        <svg class="mr-2" width="16" height="16" viewBox="0 0 18 18" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M6.039 5.13579L8.1 3.06528V11.6984C8.1 11.9372 8.19482 12.1662 8.3636 12.335C8.53239 12.5038 8.76131 12.5987 9 12.5987C9.23869 12.5987 9.46761 12.5038 9.6364 12.335C9.80518 12.1662 9.9 11.9372 9.9 11.6984V3.06528L11.961 5.13579C12.0447 5.22017 12.1442 5.28714 12.2539 5.33284C12.3636 5.37855 12.4812 5.40208 12.6 5.40208C12.7188 5.40208 12.8364 5.37855 12.9461 5.33284C13.0558 5.28714 13.1553 5.22017 13.239 5.13579C13.3234 5.05211 13.3903 4.95254 13.436 4.84284C13.4817 4.73314 13.5052 4.61547 13.5052 4.49663C13.5052 4.37779 13.4817 4.26013 13.436 4.15043C13.3903 4.04073 13.3234 3.94116 13.239 3.85747L9.639 0.256576C9.55341 0.174619 9.45248 0.110375 9.342 0.067529C9.12288 -0.0225097 8.87712 -0.0225097 8.658 0.067529C8.54752 0.110375 8.44659 0.174619 8.361 0.256576L4.761 3.85747C4.67709 3.94141 4.61052 4.04106 4.56511 4.15072C4.51969 4.26039 4.49632 4.37793 4.49632 4.49663C4.49632 4.61534 4.51969 4.73288 4.56511 4.84254C4.61052 4.95221 4.67709 5.05186 4.761 5.13579C4.84491 5.21973 4.94454 5.28631 5.05418 5.33173C5.16382 5.37716 5.28133 5.40054 5.4 5.40054C5.51867 5.40054 5.63618 5.37716 5.74582 5.33173C5.85546 5.28631 5.95509 5.21973 6.039 5.13579ZM17.1 8.99776C16.8613 8.99776 16.6324 9.0926 16.4636 9.26142C16.2948 9.43025 16.2 9.65922 16.2 9.89798V15.2993C16.2 15.5381 16.1052 15.7671 15.9364 15.9359C15.7676 16.1047 15.5387 16.1996 15.3 16.1996H2.7C2.4613 16.1996 2.23239 16.1047 2.0636 15.9359C1.89482 15.7671 1.8 15.5381 1.8 15.2993V9.89798C1.8 9.65922 1.70518 9.43025 1.5364 9.26142C1.36761 9.0926 1.13869 8.99776 0.9 8.99776C0.661305 8.99776 0.432387 9.0926 0.263604 9.26142C0.0948211 9.43025 0 9.65922 0 9.89798V15.2993C0 16.0156 0.284464 16.7025 0.790812 17.209C1.29716 17.7155 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.7155 17.2092 17.209C17.7155 16.7025 18 16.0156 18 15.2993V9.89798C18 9.65922 17.9052 9.43025 17.7364 9.26142C17.5676 9.0926 17.3387 8.99776 17.1 8.99776Z"
                            fill="white" />
                        </svg>
                        Chọn file
                      </button>
                    </div>
                    <input id="pdf-update" class="d-none" name="pdf-update" type="file" @change="onSelectFileUpdate" />
                  </div>
                  <div class="row mb-3">
                    <div v-if="editingMode === 'update'" class="col-12 flex justify-center">
                      <button :disabled="loadingList" @click="closeUpdate" type="button"
                        class="btn bg-secondary text-white mt-2">
                        Hủy
                      </button>
                      <button @click="onUpdate" :disabled="loadingList" type="button"
                        class="btn bg-pri text-white mt-2 ml-2">
                        Cập nhật
                      </button>
                    </div>
                  </div>

                  <div class="mb-3" v-if="editingInd.pdf_url && editingMode === 'view'">
                    <div class>Phiếu chỉ định</div>
                    <div class="row mt-2">
                      <a target="_blank" :href="editingInd.pdf_url" class>
                        <svg v-if="editingInd.pdf_url" class="mr-1" width="16" height="20" viewBox="0 0 16 20"
                          fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.12493 0H9.81158L15.4787 5.90705V17.3963C15.4787 18.8356 14.3143 20 12.88 20H3.12493C1.68565 20 0.52124 18.8356 0.52124 17.3963V2.60369C0.521215 1.16441 1.68563 0 3.12493 0V0Z"
                            fill="#E5252A" />
                          <path opacity="0.302" fill-rule="evenodd" clip-rule="evenodd"
                            d="M9.80664 0V5.86208H15.4788L9.80664 0Z" fill="white" />
                          <path
                            d="M3.41479 14.9226V11.2694H4.96902C5.35384 11.2694 5.65869 11.3744 5.88857 11.5892C6.11845 11.7991 6.23341 12.084 6.23341 12.4388C6.23341 12.7936 6.11845 13.0785 5.88857 13.2884C5.65869 13.5033 5.35384 13.6082 4.96902 13.6082H4.34933V14.9226H3.41479ZM4.34933 12.8136H4.86408C5.004 12.8136 5.11395 12.7837 5.18892 12.7137C5.26387 12.6487 5.30388 12.5588 5.30388 12.4388C5.30388 12.3189 5.2639 12.229 5.18892 12.164C5.11397 12.094 5.00402 12.064 4.86408 12.064H4.34933V12.8136ZM6.61819 14.9226V11.2694H7.91255C8.16742 11.2694 8.40731 11.3044 8.63219 11.3794C8.85706 11.4543 9.06198 11.5593 9.24187 11.7042C9.4218 11.8441 9.56672 12.034 9.67167 12.2739C9.77161 12.5138 9.8266 12.7887 9.8266 13.0985C9.8266 13.4033 9.77163 13.6782 9.67167 13.9181C9.56672 14.158 9.4218 14.3479 9.24187 14.4878C9.06195 14.6327 8.85706 14.7376 8.63219 14.8126C8.40731 14.8876 8.16742 14.9226 7.91255 14.9226H6.61819ZM7.53274 14.128H7.8026C7.94752 14.128 8.08246 14.113 8.2074 14.078C8.32733 14.043 8.44228 13.988 8.55223 13.9131C8.65718 13.8381 8.74214 13.7332 8.8021 13.5932C8.86207 13.4533 8.89206 13.2884 8.89206 13.0985C8.89206 12.9036 8.86207 12.7387 8.8021 12.5988C8.74214 12.4588 8.65718 12.3539 8.55223 12.2789C8.44228 12.204 8.32735 12.149 8.2074 12.114C8.08246 12.079 7.94752 12.064 7.8026 12.064H7.53274V14.128ZM10.2964 14.9226V11.2694H12.8951V12.064H11.2309V12.6487H12.5602V13.4383H11.2309V14.9226H10.2964Z"
                            fill="white" />
                        </svg>
                        <span>{{
                          editingInd.pdf_url
                            ? getFilename(editingInd.pdf_url)
                            : ""
                        }}</span>
                      </a>
                    </div>
                  </div>

                  <div v-if="!editingInd.result && editingMode === 'view'" class="flex flex-col align-items-center">
                    <img src="../../../../assets/images/blank-stage/chua-co-kq.png" alt class="w-2/12 mb-3" />
                    <div class="fs-20 txt-grey-900 mb-3">Chưa có kết quả</div>
                    <div class="flex">
                      <div class="btn bg-pri text-white cursor-pointer" @click="editingMode = 'result'">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                          class="mr-1">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M14.3586 1.94065C14.3586 1.11952 13.6929 0.453857 12.8718 0.453857C12.0506 0.453857 11.385 1.11952 11.385 1.94065L11.385 10.8614L2.25291 10.8614C1.43177 10.8614 0.766113 11.5271 0.766113 12.3482C0.766113 13.1693 1.43177 13.835 2.25291 13.835H11.385L11.385 22.9671C11.385 23.7882 12.0506 24.4539 12.8718 24.4539C13.6929 24.4539 14.3586 23.7882 14.3586 22.9671L14.3586 13.835H23.2793C24.1005 13.835 24.7661 13.1693 24.7661 12.3482C24.7661 11.5271 24.1005 10.8614 23.2793 10.8614L14.3586 10.8614L14.3586 1.94065Z"
                            fill="white" />
                        </svg>
                        <span class="fs-18 fw-500">Thêm kết quả</span>
                      </div>
                      <div class="btn bg-pri text-white cursor-pointer ml-2" v-if="!formResult.conclusion && !hideEdit"
                        @click="showUpdate">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M15.75 8.98568C15.5511 8.98568 15.3603 9.06 15.2197 9.19228C15.079 9.32457 15 9.50399 15 9.69107V13.9234C15 14.1105 14.921 14.2899 14.7803 14.4222C14.6397 14.5545 14.4489 14.6288 14.25 14.6288H3.75C3.55109 14.6288 3.36032 14.5545 3.21967 14.4222C3.07902 14.2899 3 14.1105 3 13.9234V4.04798C3 3.8609 3.07902 3.68148 3.21967 3.5492C3.36032 3.41691 3.55109 3.3426 3.75 3.3426H8.25C8.44891 3.3426 8.63968 3.26828 8.78033 3.13599C8.92098 3.00371 9 2.82429 9 2.63721C9 2.45013 8.92098 2.27071 8.78033 2.13843C8.63968 2.00614 8.44891 1.93182 8.25 1.93182H3.75C3.15326 1.93182 2.58097 2.15478 2.15901 2.55163C1.73705 2.94849 1.5 3.48674 1.5 4.04798V13.9234C1.5 14.4846 1.73705 15.0229 2.15901 15.4197C2.58097 15.8166 3.15326 16.0395 3.75 16.0395H14.25C14.8467 16.0395 15.419 15.8166 15.841 15.4197C16.2629 15.0229 16.5 14.4846 16.5 13.9234V9.69107C16.5 9.50399 16.421 9.32457 16.2803 9.19228C16.1397 9.06 15.9489 8.98568 15.75 8.98568ZM4.5 9.52177V12.5126C4.5 12.6997 4.57902 12.8791 4.71967 13.0114C4.86032 13.1437 5.05109 13.218 5.25 13.218H8.43C8.5287 13.2185 8.62655 13.2007 8.71793 13.1656C8.80931 13.1305 8.89242 13.0788 8.9625 13.0134L14.1525 8.12511L16.2825 6.16414C16.3528 6.09856 16.4086 6.02055 16.4467 5.93459C16.4847 5.84863 16.5043 5.75643 16.5043 5.66331C16.5043 5.5702 16.4847 5.478 16.4467 5.39204C16.4086 5.30608 16.3528 5.22807 16.2825 5.16249L13.1025 2.13639C13.0328 2.07027 12.9498 2.01779 12.8584 1.98198C12.767 1.94617 12.669 1.92773 12.57 1.92773C12.471 1.92773 12.373 1.94617 12.2816 1.98198C12.1902 2.01779 12.1072 2.07027 12.0375 2.13639L9.9225 4.13263L4.7175 9.02095C4.64799 9.08686 4.59299 9.16503 4.55567 9.25097C4.51835 9.33692 4.49943 9.42894 4.5 9.52177ZM12.57 3.6318L14.6925 5.62805L13.6275 6.62969L11.505 4.63345L12.57 3.6318ZM6 9.81098L10.4475 5.62805L12.57 7.62429L8.1225 11.8072H6V9.81098Z"
                            fill="white" />
                        </svg>
                        <span class="fs-18 fw-500">Sửa chỉ định</span>
                      </div>
                    </div>
                  </div>
                </template>

                <div class="sticky" style="top: 24px" v-if="editingMode === 'result'">
                  <div class="mb-3">
                    <label class="fs-14 fw-700 txt-grey-900 mb-2 flex align-items-center" :class="{
                      required: editingMode === 'result' && !(hasEHCConnect || hasVimesSync),
                    }">
                      <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" fill="none"
                          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Kết luận:
                    </label>
                    <template v-if="hasEHCConnect || hasVimesSync">
                      <textarea v-if="editingMode === 'result'" rows="3" readonly class="form-control border w-full"
                        v-model="formResult.conclusion"></textarea>
                      <div v-if="editingMode === 'view'" v-html="formResult.conclusion"></div>
                    </template>
                    <template v-else>
                      <textarea v-if="editingMode === 'result'" rows="3" class="form-control border w-full" :class="{
                        'bg-white': !(hasEHCConnect || hasVimesSync),
                      }" v-model="formResult.conclusion"></textarea>
                      <div v-if="editingMode === 'view'" v-html="formResult.conclusion"></div>
                    </template>
                  </div>

                  <div class="mb-3">
                    <label class="fs-14 fw-700 txt-grey-900 mb-2 flex align-items-center">
                      <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="none"
                          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M14 2v6h6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                      Mô tả:
                    </label>
                    <template v-if="hasEHCConnect || hasVimesSync">
                      <textarea v-if="editingMode === 'result'" rows="4" readonly class="form-control border w-full"
                        v-model="formResult.description"></textarea>
                      <div v-if="editingMode === 'view'" v-html="formResult.description"></div>
                    </template>
                    <template v-else>
                      <textarea v-if="editingMode === 'result'" rows="4" class="form-control border w-full" :class="{
                        'bg-white': !(hasEHCConnect || hasVimesSync),
                      }" v-model="formResult.description"></textarea>
                      <div v-if="editingMode === 'view'" v-html="formResult.description"></div>
                    </template>
                  </div>

                  <div class="mb-3">
                    <label class="fs-14 fw-700 txt-grey-900 mb-2 flex align-items-center"
                      :class="{ required: editingMode === 'result' }">
                      <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="mr-2">
                        <path
                          d="M10.3931 15.5437V16.1267C10.3931 17.3202 10.9019 18.4648 11.8075 19.3087C12.7131 20.1526 13.9413 20.6267 15.2221 20.6267C16.5028 20.6267 17.7311 20.1526 18.6367 19.3087C19.5423 18.4648 20.051 17.3202 20.051 16.1267V14.4567C19.3348 14.2208 18.731 13.7565 18.3466 13.1459C17.9621 12.5353 17.8217 11.8177 17.9501 11.1199C18.0785 10.4222 18.4675 9.78917 19.0484 9.33284C19.6292 8.87651 20.3644 8.62622 21.1242 8.62622C21.8839 8.62622 22.6191 8.87651 23.1999 9.33284C23.7808 9.78917 24.1698 10.4222 24.2982 11.1199C24.4266 11.8177 24.2862 12.5353 23.9017 13.1459C23.5173 13.7565 22.9135 14.2208 22.1973 14.4567V16.1267C22.1973 17.8506 21.4624 19.5039 20.1543 20.7229C18.8462 21.9419 17.072 22.6267 15.2221 22.6267C13.3721 22.6267 11.598 21.9419 10.2899 20.7229C8.98176 19.5039 8.24688 17.8506 8.24688 16.1267V15.5437C6.7466 15.307 5.3847 14.5829 4.40258 13.4999C3.42046 12.4168 2.88154 11.0447 2.88135 9.62671L2.88135 4.62671C2.88135 4.09628 3.10747 3.58757 3.50996 3.2125C3.91245 2.83742 4.45835 2.62671 5.02756 2.62671H6.10067C6.38527 2.62671 6.65822 2.73207 6.85947 2.9196C7.06071 3.10714 7.17377 3.36149 7.17377 3.62671C7.17377 3.89193 7.06071 4.14628 6.85947 4.33382C6.65822 4.52135 6.38527 4.62671 6.10067 4.62671H5.02756V9.62671C5.02756 10.6876 5.4798 11.705 6.28478 12.4551C7.08977 13.2053 8.18156 13.6267 9.31998 13.6267C10.4584 13.6267 11.5502 13.2053 12.3552 12.4551C13.1602 11.705 13.6124 10.6876 13.6124 9.62671V4.62671H12.5393C12.2547 4.62671 11.9817 4.52135 11.7805 4.33382C11.5793 4.14628 11.4662 3.89193 11.4662 3.62671C11.4662 3.36149 11.5793 3.10714 11.7805 2.9196C11.9817 2.73207 12.2547 2.62671 12.5393 2.62671H13.6124C14.1816 2.62671 14.7275 2.83742 15.13 3.2125C15.5325 3.58757 15.7586 4.09628 15.7586 4.62671V9.62671C15.7584 11.0447 15.2195 12.4168 14.2374 13.4999C13.2553 14.5829 11.8934 15.307 10.3931 15.5437ZM21.1242 12.6267C21.4088 12.6267 21.6817 12.5214 21.883 12.3338C22.0842 12.1463 22.1973 11.8919 22.1973 11.6267C22.1973 11.3615 22.0842 11.1071 21.883 10.9196C21.6817 10.7321 21.4088 10.6267 21.1242 10.6267C20.8395 10.6267 20.5666 10.7321 20.3654 10.9196C20.1641 11.1071 20.051 11.3615 20.051 11.6267C20.051 11.8919 20.1641 12.1463 20.3654 12.3338C20.5666 12.5214 20.8395 12.6267 21.1242 12.6267Z"
                          fill="black" />
                      </svg>
                      Nhận xét:
                    </label>
                    <CkeditorNormal v-if="editingMode === 'result'" @onEditorInput="
                      (t) => {
                        formResult.comment = t;
                      }
                    " :prop_text="formResult.comment" :placeholder="'Nhận xét'" :class_style="'bg-white p-0 txt-black'"
                      :id="'inputTextComment'">
                    </CkeditorNormal>
                    <div v-if="editingMode === 'view'" v-html="formResult.comment"></div>
                  </div>

                  <div class="mb-3">
                    <div class="fs-14 fw-700 txt-grey-900 mb-2 flex align-items-center">
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="mr-2">
                        <path
                          d="M20.0961 7.57873C20.1833 7.48633 20.2885 7.41272 20.4052 7.3624C20.5218 7.31209 20.6475 7.28614 20.7746 7.28614C20.9017 7.28614 21.0274 7.31209 21.1441 7.3624C21.2607 7.41272 21.3659 7.48633 21.4531 7.57873C21.8281 7.96873 21.8281 8.60073 21.4531 8.99073L9.9231 20.9997C9.48721 21.4617 8.96155 21.8297 8.37836 22.0812C7.79516 22.3328 7.16673 22.4625 6.5316 22.4625C5.89647 22.4625 5.26804 22.3328 4.68484 22.0812C4.10165 21.8297 3.57599 21.4617 3.1401 20.9997C1.2671 19.0497 1.2671 15.8867 3.1401 13.9357L13.3131 3.33973C13.5747 3.06256 13.8901 2.84174 14.24 2.69081C14.5899 2.53989 14.967 2.46204 15.3481 2.46204C15.7292 2.46204 16.1063 2.53989 16.4562 2.69081C16.8061 2.84174 17.1216 3.06256 17.3831 3.33973C18.5071 4.50973 18.5071 6.40773 17.3831 7.57873L8.5651 16.7597C8.4779 16.852 8.3728 16.9255 8.25622 16.9757C8.13964 17.0259 8.01404 17.0518 7.8871 17.0518C7.76017 17.0518 7.63457 17.0259 7.51799 16.9757C7.40141 16.9255 7.2963 16.852 7.2091 16.7597C7.02879 16.5689 6.92833 16.3163 6.92833 16.0537C6.92833 15.7912 7.02879 15.5386 7.2091 15.3477L16.0271 6.16473C16.2077 5.97383 16.3083 5.72102 16.3083 5.45823C16.3083 5.19544 16.2077 4.94262 16.0271 4.75173C15.9399 4.65933 15.8347 4.58572 15.7181 4.5354C15.6014 4.48509 15.4757 4.45914 15.3486 4.45914C15.2215 4.45914 15.0958 4.48509 14.9792 4.5354C14.8625 4.58572 14.7573 4.65933 14.6701 4.75173L4.4951 15.3497C3.3721 16.5197 3.3721 18.4177 4.4951 19.5877C4.75665 19.8649 5.07206 20.0857 5.422 20.2366C5.77193 20.3876 6.14901 20.4654 6.5301 20.4654C6.91119 20.4654 7.28827 20.3876 7.6382 20.2366C7.98814 20.0857 8.30355 19.8649 8.5651 19.5877L20.0961 7.57873Z"
                          fill="black" />
                      </svg>

                      <div v-if="editingMode === 'result'">Chọn file:</div>
                      <div v-else>Phiếu kết quả:</div>
                    </div>
                    <div>
                      <div v-if="editingMode === 'result'">
                        <div class="btn-upload-file mr-0" @click="uploadDocs">
                          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="mr-2">
                            <path
                              d="M7.55798 6.69868L9.46631 4.78201V12.7737C9.46631 12.9947 9.55411 13.2067 9.71039 13.3629C9.86667 13.5192 10.0786 13.607 10.2996 13.607C10.5207 13.607 10.7326 13.5192 10.8889 13.3629C11.0452 13.2067 11.133 12.9947 11.133 12.7737V4.78201L13.0413 6.69868C13.1188 6.77679 13.2109 6.83878 13.3125 6.88109C13.414 6.9234 13.523 6.94518 13.633 6.94518C13.743 6.94518 13.8519 6.9234 13.9535 6.88109C14.055 6.83878 14.1472 6.77679 14.2246 6.69868C14.3027 6.62121 14.3647 6.52905 14.4071 6.4275C14.4494 6.32595 14.4711 6.21703 14.4711 6.10702C14.4711 5.99701 14.4494 5.88808 14.4071 5.78653C14.3647 5.68499 14.3027 5.59282 14.2246 5.51535L10.8913 2.18202C10.8121 2.10615 10.7186 2.04668 10.6163 2.00702C10.4134 1.92367 10.1859 1.92367 9.98298 2.00702C9.88068 2.04668 9.78723 2.10615 9.70798 2.18202L6.37464 5.51535C6.29694 5.59305 6.23531 5.68529 6.19326 5.78681C6.15121 5.88833 6.12957 5.99713 6.12957 6.10702C6.12957 6.2169 6.15121 6.3257 6.19326 6.42722C6.23531 6.52874 6.29694 6.62098 6.37464 6.69868C6.45234 6.77638 6.54458 6.83801 6.6461 6.88006C6.74762 6.92211 6.85643 6.94376 6.96631 6.94376C7.07619 6.94376 7.185 6.92211 7.28652 6.88006C7.38804 6.83801 7.48028 6.77638 7.55798 6.69868ZM17.7996 10.2737C17.5786 10.2737 17.3667 10.3615 17.2104 10.5178C17.0541 10.674 16.9663 10.886 16.9663 11.107V16.107C16.9663 16.328 16.8785 16.54 16.7222 16.6963C16.566 16.8526 16.354 16.9403 16.133 16.9403H4.46631C4.24529 16.9403 4.03333 16.8526 3.87705 16.6963C3.72077 16.54 3.63298 16.328 3.63298 16.107V11.107C3.63298 10.886 3.54518 10.674 3.3889 10.5178C3.23262 10.3615 3.02066 10.2737 2.79964 10.2737C2.57863 10.2737 2.36667 10.3615 2.21039 10.5178C2.05411 10.674 1.96631 10.886 1.96631 11.107V16.107C1.96631 16.7701 2.2297 17.4059 2.69854 17.8748C3.16738 18.3436 3.80327 18.607 4.46631 18.607H16.133C16.796 18.607 17.4319 18.3436 17.9007 17.8748C18.3696 17.4059 18.633 16.7701 18.633 16.107V11.107C18.633 10.886 18.5452 10.674 18.3889 10.5178C18.2326 10.3615 18.0207 10.2737 17.7996 10.2737Z"
                              fill="#20409B" />
                          </svg>
                          <span class="txt-pri fs-14">
                            {{
                              resultDocuments &&
                                resultDocuments.files &&
                                resultDocuments.files.length
                                ? `Đã chọn
                            ${resultDocuments.files.length} files`
                                : "Chọn file"
                            }}
                          </span>
                        </div>
                      </div>
                      <template v-if="editingMode === 'result'" v-for="uploadedFile in uploadedFiles">
                        <div class="inline-block" :key="uploadedFile.id + 'udfile'" v-if="!uploadedFile.pacs_id"
                          @click="openUrl(uploadedFile.file_name)">
                          <div class="file-item" :class="uploadedFiles.length > 1 ? 'mb-2' : ''">
                            <span>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_24814_125783)">
                                  <path
                                    d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                                    fill="#0263D1" />
                                  <path opacity="0.302" fill-rule="evenodd" clip-rule="evenodd"
                                    d="M14.1675 0V7.0337H20.9747L14.1675 0Z" fill="white" />
                                  <path
                                    d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                                    fill="white" />
                                  <path d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z" fill="white" />
                                  <path d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                                    fill="white" />
                                  <path
                                    d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                                    fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_24814_125783">
                                    <rect width="24" height="24" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            {{ uploadedFile.name }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="mb-3">
                    <div>
                      <div v-if="editingMode === 'view' && editingInd.result">
                        <a v-for="uploadedLink in uploadedLinks" :key="uploadedLink.id + 'uploadedLink'" target="_blank"
                          :href="uploadedLink.url" class="txt-pri fs-14 text-decoration-underline d-block mb-3">
                          <span>{{ uploadedLink.name }}</span>
                        </a>
                      </div>

                      <!-- show in-progress/new links (with delete) only when adding/editing result -->
                      <div v-if="editingMode === 'result'" v-for="(link, i) in links" :key="i + 'link.url'"
                        class="mb-3 flex justify-content-between link-item">
                        <a target="_blank" :href="link.url" class="txt-pri fs-14 text-decoration-underline">{{ link.name
                          }}</a>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                          @click.stop="deleteLink(i)">
                          <path d="M6 17.9998L17.9998 6" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M17.9998 17.9998L6 6" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>

                      <a v-if="editingMode === 'result'" href="javascript:;"
                        class="txt-pri fs-14 text-decoration-underline d-block fw-500"
                        @click="modalUploadResultLink(true)">Thêm link</a>
                    </div>
                  </div>
                  <div class="mt-3 flex justify-content-center">
                    <div v-if="editingMode === 'view'" class="btn cursor-pointer bg-pri text-white" @click="showResult">
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="mr-2">
                        <path
                          d="M8.22 16.956L9.981 16.448L20.584 5.71797C20.6676 5.63226 20.7142 5.5171 20.7136 5.39735C20.7131 5.27761 20.6654 5.16288 20.581 5.07797L19.946 4.43597C19.905 4.39381 19.8559 4.36024 19.8018 4.33723C19.7477 4.31421 19.6895 4.30222 19.6306 4.30194C19.5718 4.30166 19.5135 4.3131 19.4591 4.3356C19.4048 4.3581 19.3554 4.3912 19.314 4.43297L8.739 15.135L8.219 16.955L8.22 16.956ZM21.203 3.16397L21.838 3.80697C22.714 4.69397 22.722 6.12497 21.854 7.00297L10.928 18.061L7.164 19.145C6.9342 19.2093 6.68826 19.1798 6.48016 19.063C6.27206 18.9462 6.1188 18.7516 6.054 18.522C6.00578 18.3568 6.00509 18.1815 6.052 18.016L7.147 14.176L18.044 3.14697C18.2512 2.93833 18.4979 2.77303 18.7696 2.66072C19.0414 2.54841 19.3328 2.49134 19.6269 2.49283C19.9209 2.49432 20.2117 2.55434 20.4823 2.6694C20.7529 2.78445 20.9979 2.95224 21.203 3.16297V3.16397ZM9.684 4.31697C10.18 4.31697 10.582 4.72397 10.582 5.22597C10.5828 5.34464 10.5602 5.4623 10.5155 5.57222C10.4708 5.68215 10.4048 5.78218 10.3214 5.8666C10.238 5.95102 10.1388 6.01818 10.0294 6.06423C9.92004 6.11028 9.80267 6.13431 9.684 6.13497H6.092C5.1 6.13497 4.296 6.94897 4.296 7.95197V18.858C4.296 19.862 5.1 20.676 6.092 20.676H16.868C17.86 20.676 18.665 19.862 18.665 18.858V15.223C18.665 14.721 19.067 14.314 19.563 14.314C20.059 14.314 20.461 14.721 20.461 15.224V18.858C20.461 20.866 18.852 22.494 16.868 22.494H6.092C4.108 22.494 2.5 20.866 2.5 18.858V7.95197C2.5 5.94497 4.108 4.31697 6.092 4.31697H9.684Z"
                          fill="white" />
                      </svg>
                      <span>Cập nhật</span>
                    </div>
                    <template v-if="editingMode === 'result'">
                      <div class="btn cursor-pointer bg-secondary text-white mr-2"
                        @click="() => (editingMode = 'view')">
                        <span>Quay lại</span>
                      </div>
                      <div class="btn cursor-pointer bg-pri text-white" :class="loadingDetail ? 'disabled' : ''"
                        @click="createEmrIndicationResult">
                        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg"
                          class="mr-2">
                          <path
                            d="M13.0339 19.5183C12.8808 19.5186 12.7291 19.4887 12.5875 19.4302C12.446 19.3718 12.3174 19.2859 12.2091 19.1777L7.26007 14.2275C7.14857 14.12 7.0596 13.9913 6.99836 13.849C6.93712 13.7067 6.90483 13.5536 6.90337 13.3987C6.90192 13.2438 6.93133 13.0902 6.98989 12.9467C7.04845 12.8033 7.13498 12.673 7.24445 12.5634C7.35391 12.4538 7.48411 12.3671 7.62744 12.3083C7.77078 12.2495 7.92438 12.2199 8.07929 12.2211C8.2342 12.2224 8.38731 12.2544 8.52969 12.3155C8.67207 12.3765 8.80087 12.4653 8.90857 12.5767L13.0327 16.7008L20.4586 9.27733C20.6773 9.05841 20.9741 8.93537 21.2836 8.93526C21.5931 8.93515 21.8899 9.05798 22.1088 9.27674C22.3277 9.4955 22.4508 9.79227 22.4509 10.1017C22.451 10.4112 22.3282 10.7081 22.1094 10.927L13.8587 19.1777C13.7504 19.2859 13.6218 19.3718 13.4803 19.4302C13.3387 19.4887 13.187 19.5186 13.0339 19.5183Z"
                            fill="white" />
                        </svg>
                        <span>Xác nhận Kết Quả</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div v-if="(
                (editingInd.result && editingMode !== 'update') ||
                (tableIndicationsResult && tableIndicationsResult.length > 0) ||
                (linksRes && linksRes.length > 0)
              ) && indType === 1" class="col-8">
                <TestResultForm ref="testResultForm" :indicator="editingInd" :emrIndicationRead="emrIndicationRead"
                  :links="linksRes" @setTableIndicationsResult="setTableIndicationsResult" @saveNewLink="saveNewLink"
                  @setIsLoadingDetail="setIsLoadingDetail" @refresh="getEmrIndicationResult"
                  @submitLinks="postEmrIndicationResultFile">
                </TestResultForm>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalEmrIndication" tabindex="-1" role="dialog"
      aria-labelledby="modalEmrIndicationLabel" aria-hidden="true">
      <div class="modal-dialog modal-sx" role="document">
        <div class="modal-content" v-loading="loadingList">
          <div class="d-flex justify-content-between p-3">
            <div class="fs-24 fw-700 txt-grey-900 text-center w-100">
              <span v-if="checkType === 1">Upload Phiếu</span>
              <span v-else>Tạo mới chỉ định</span>
            </div>
          </div>
          <div class="modal-body">
            <div class="mb-3 row">
              <div class="col-md-3">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Tên chỉ định</p>
              </div>
              <div class="col-md-9">
                <el-input v-model="formCreate.name" class="w-100 col-md-5" placeholder="Nhập Tên Chỉ Định"></el-input>
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-3">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Ngày chỉ định</p>
              </div>
              <div class="col-md-9">
                <input v-model="formCreate.date" type="datetime-local" class="form-control fw-500 txt-grey-900" />
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-3">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">
                  Bác sĩ chỉ định
                </p>
              </div>
              <div class="col-md-9">
                <el-select v-model="formCreate.indicator_id" filterable allow-create remote reserve-keyword
                  placeholder="Tìm kiếm tên" class="w-100" :remote-method="getDoctor" :loading="loadingDoctor">
                  <el-option v-for="item in doctors" :key="item.id + 'dtr'" :label="item.name"
                    :value="item.user_id"></el-option>
                </el-select>
              </div>
            </div>

            <div class="mb-3 row" v-if="$globalClinic">
              <div class="col-md-3">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Khoa chỉ định</p>
              </div>
              <div class="col-md-9">
                <el-input class="w-100" :value="$globalClinic.name" :readonly="true"></el-input>
              </div>
            </div>

            <div class="mb-3 row" v-if="checkType === 1">
              <div class="col-md-9">
                <p class="mt-2 fs-14">
                  {{ pdf_file ? pdf_file.name : "Chưa chọn file..." }}
                </p>
              </div>
              <div class="col-md-3">
                <div v-if="pdf_file" @click="onShowPickPdf"
                  class="mt-3 ml-4 fs-16 text-blue-900 underline cursor-pointer hover:text-blue-500">
                  Thay đổi
                </div>
                <button v-if="!pdf_file" @click="onShowPickPdf" type="button" class="btn bg-pri text-white mt-2">
                  <svg class="mr-2" width="16" height="16" viewBox="0 0 18 18" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.039 5.13579L8.1 3.06528V11.6984C8.1 11.9372 8.19482 12.1662 8.3636 12.335C8.53239 12.5038 8.76131 12.5987 9 12.5987C9.23869 12.5987 9.46761 12.5038 9.6364 12.335C9.80518 12.1662 9.9 11.9372 9.9 11.6984V3.06528L11.961 5.13579C12.0447 5.22017 12.1442 5.28714 12.2539 5.33284C12.3636 5.37855 12.4812 5.40208 12.6 5.40208C12.7188 5.40208 12.8364 5.37855 12.9461 5.33284C13.0558 5.28714 13.1553 5.22017 13.239 5.13579C13.3234 5.05211 13.3903 4.95254 13.436 4.84284C13.4817 4.73314 13.5052 4.61547 13.5052 4.49663C13.5052 4.37779 13.4817 4.26013 13.436 4.15043C13.3903 4.04073 13.3234 3.94116 13.239 3.85747L9.639 0.256576C9.55341 0.174619 9.45248 0.110375 9.342 0.067529C9.12288 -0.0225097 8.87712 -0.0225097 8.658 0.067529C8.54752 0.110375 8.44659 0.174619 8.361 0.256576L4.761 3.85747C4.67709 3.94141 4.61052 4.04106 4.56511 4.15072C4.51969 4.26039 4.49632 4.37793 4.49632 4.49663C4.49632 4.61534 4.51969 4.73288 4.56511 4.84254C4.61052 4.95221 4.67709 5.05186 4.761 5.13579C4.84491 5.21973 4.94454 5.28631 5.05418 5.33173C5.16382 5.37716 5.28133 5.40054 5.4 5.40054C5.51867 5.40054 5.63618 5.37716 5.74582 5.33173C5.85546 5.28631 5.95509 5.21973 6.039 5.13579ZM17.1 8.99776C16.8613 8.99776 16.6324 9.0926 16.4636 9.26142C16.2948 9.43025 16.2 9.65922 16.2 9.89798V15.2993C16.2 15.5381 16.1052 15.7671 15.9364 15.9359C15.7676 16.1047 15.5387 16.1996 15.3 16.1996H2.7C2.4613 16.1996 2.23239 16.1047 2.0636 15.9359C1.89482 15.7671 1.8 15.5381 1.8 15.2993V9.89798C1.8 9.65922 1.70518 9.43025 1.5364 9.26142C1.36761 9.0926 1.13869 8.99776 0.9 8.99776C0.661305 8.99776 0.432387 9.0926 0.263604 9.26142C0.0948211 9.43025 0 9.65922 0 9.89798V15.2993C0 16.0156 0.284464 16.7025 0.790812 17.209C1.29716 17.7155 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.7155 17.2092 17.209C17.7155 16.7025 18 16.0156 18 15.2993V9.89798C18 9.65922 17.9052 9.43025 17.7364 9.26142C17.5676 9.0926 17.3387 8.99776 17.1 8.99776Z"
                      fill="white" />
                  </svg>
                  Chọn file
                </button>
                <input id="pdf-upload" class="d-none" name="pdf-upload" type="file" @change="onSelectPdf"
                  :key="fileInputKey" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button id="CloseModal" type="button" class="btn bg-white text-blue-900" data-dismiss="modal"
              @click="CloseModal">
              Hủy
            </button>
            <button v-if="checkType === 1" @click="onUpload" :disabled="loadingList" type="button"
              class="btn bg-pri text-white">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.34961 3.61963H16.5696C17.067 3.61968 17.5465 3.80508 17.9146 4.13963L20.6946 6.66663C20.9009 6.85406 21.0657 7.08254 21.1785 7.33741C21.2913 7.59228 21.3496 7.86791 21.3496 8.14663V19.6196C21.3496 20.1501 21.1389 20.6588 20.7638 21.0338C20.3888 21.4089 19.88 21.6196 19.3496 21.6196H5.34961C4.81918 21.6196 4.31047 21.4089 3.9354 21.0338C3.56032 20.6588 3.34961 20.1501 3.34961 19.6196V5.61963C3.34961 5.0892 3.56032 4.58049 3.9354 4.20542C4.31047 3.83034 4.81918 3.61963 5.34961 3.61963V3.61963ZM5.34961 5.61963V19.6196H19.3496V8.14663L16.5696 5.61963H5.34961ZM9.34961 13.6196H15.3496C15.88 13.6196 16.3888 13.8303 16.7638 14.2054C17.1389 14.5805 17.3496 15.0892 17.3496 15.6196V19.6196C17.3496 20.1501 17.1389 20.6588 16.7638 21.0338C16.3888 21.4089 15.88 21.6196 15.3496 21.6196H9.34961C8.81918 21.6196 8.31047 21.4089 7.9354 21.0338C7.56032 20.6588 7.34961 20.1501 7.34961 19.6196V15.6196C7.34961 15.0892 7.56032 14.5805 7.9354 14.2054C8.31047 13.8303 8.81918 13.6196 9.34961 13.6196ZM9.34961 15.6196V19.6196H15.3496V15.6196H9.34961ZM16.3496 6.61963C16.6148 6.61963 16.8692 6.72499 17.0567 6.91252C17.2443 7.10006 17.3496 7.35441 17.3496 7.61963V10.6196C17.3496 10.8848 17.2443 11.1392 17.0567 11.3267C16.8692 11.5143 16.6148 11.6196 16.3496 11.6196C16.0844 11.6196 15.83 11.5143 15.6425 11.3267C15.455 11.1392 15.3496 10.8848 15.3496 10.6196V7.61963C15.3496 7.35441 15.455 7.10006 15.6425 6.91252C15.83 6.72499 16.0844 6.61963 16.3496 6.61963ZM8.34961 6.61963H13.3496C13.6148 6.61963 13.8692 6.72499 14.0567 6.91252C14.2443 7.10006 14.3496 7.35441 14.3496 7.61963V10.6196C14.3496 10.8848 14.2443 11.1392 14.0567 11.3267C13.8692 11.5143 13.6148 11.6196 13.3496 11.6196H8.34961C8.08439 11.6196 7.83004 11.5143 7.6425 11.3267C7.45497 11.1392 7.34961 10.8848 7.34961 10.6196V7.61963C7.34961 7.35441 7.45497 7.10006 7.6425 6.91252C7.83004 6.72499 8.08439 6.61963 8.34961 6.61963ZM9.34961 9.61963H12.3496V8.61963H9.34961V9.61963Z"
                  fill="white" />
              </svg>
              Lưu
            </button>
            <button v-else @click="onCreate" type="button" class="btn bg-pri text-white">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.34961 3.61963H16.5696C17.067 3.61968 17.5465 3.80508 17.9146 4.13963L20.6946 6.66663C20.9009 6.85406 21.0657 7.08254 21.1785 7.33741C21.2913 7.59228 21.3496 7.86791 21.3496 8.14663V19.6196C21.3496 20.1501 21.1389 20.6588 20.7638 21.0338C20.3888 21.4089 19.88 21.6196 19.3496 21.6196H5.34961C4.81918 21.6196 4.31047 21.4089 3.9354 21.0338C3.56032 20.6588 3.34961 20.1501 3.34961 19.6196V5.61963C3.34961 5.0892 3.56032 4.58049 3.9354 4.20542C4.31047 3.83034 4.81918 3.61963 5.34961 3.61963V3.61963ZM5.34961 5.61963V19.6196H19.3496V8.14663L16.5696 5.61963H5.34961ZM9.34961 13.6196H15.3496C15.88 13.6196 16.3888 13.8303 16.7638 14.2054C17.1389 14.5805 17.3496 15.0892 17.3496 15.6196V19.6196C17.3496 20.1501 17.1389 20.6588 16.7638 21.0338C16.3888 21.4089 15.88 21.6196 15.3496 21.6196H9.34961C8.81918 21.6196 8.31047 21.4089 7.9354 21.0338C7.56032 20.6588 7.34961 20.1501 7.34961 19.6196V15.6196C7.34961 15.0892 7.56032 14.5805 7.9354 14.2054C8.31047 13.8303 8.81918 13.6196 9.34961 13.6196ZM9.34961 15.6196V19.6196H15.3496V15.6196H9.34961ZM16.3496 6.61963C16.6148 6.61963 16.8692 6.72499 17.0567 6.91252C17.2443 7.10006 17.3496 7.35441 17.3496 7.61963V10.6196C17.3496 10.8848 17.2443 11.1392 17.0567 11.3267C16.8692 11.5143 16.6148 11.6196 16.3496 11.6196C16.0844 11.6196 15.83 11.5143 15.6425 11.3267C15.455 11.1392 15.3496 10.8848 15.3496 10.6196V7.61963C15.3496 7.35441 15.455 7.10006 15.6425 6.91252C15.83 6.72499 16.0844 6.61963 16.3496 6.61963ZM8.34961 6.61963H13.3496C13.6148 6.61963 13.8692 6.72499 14.0567 6.91252C14.2443 7.10006 14.3496 7.35441 14.3496 7.61963V10.6196C14.3496 10.8848 14.2443 11.1392 14.0567 11.3267C13.8692 11.5143 13.6148 11.6196 13.3496 11.6196H8.34961C8.08439 11.6196 7.83004 11.5143 7.6425 11.3267C7.45497 11.1392 7.34961 10.8848 7.34961 10.6196V7.61963C7.34961 7.35441 7.45497 7.10006 7.6425 6.91252C7.83004 6.72499 8.08439 6.61963 8.34961 6.61963ZM9.34961 9.61963H12.3496V8.61963H9.34961V9.61963Z"
                  fill="white" />
              </svg>
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <UploadFiles
      :modal_id="'modalUploadResultFile'"
      :selected="resultDocuments"
      @submitFile="submitFile"
    />-->
    <UploadLink :modal_id="'modalUploadResultLink'" @addLink="addLink" />
    <input type="file" @change="onSelectedFile($event)" class="d-none" ref="inputFileEmrIndicationList" multiple />
    <input type="file" @change="onSelectedFilePacs($event)" class="d-none" ref="inputFilePacsEmrIndicationList" />
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
// import _ from 'lodash'
import CkeditorNormal from '@/components/Editors/CkeditorNormal.vue'
import UploadFiles from '@/components/Uploads/UploadFiles.vue'
import UploadLink from '@/components/Uploads/UploadLink.vue'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import uploadEmrIndicationFile from '@/utils/uploadEmrIndicationFile'
import DOMPurify from 'dompurify'
import _ from 'lodash'
import ModalUploadPacs from '../../../../components/Files/ModalUploadPacs.vue'
import appUtils from '../../../../utils/appUtils'
import uploadCircleFile from '../../../../utils/uploadCircleFile'
import uploadFileWithTenant from '../../../../utils/uploadFileWithTenant'
import TestResultForm from './TestResultFormV2.vue'

export default {
  name: 'EmrIndicationList',
  props: ['indType'],
  mixins: [mixinHasFeatures],
  components: {
    CkeditorNormal,
    UploadFiles,
    UploadLink,
    ModalUploadPacs,
    TestResultForm
  },
  data () {
    return {
      modeUpdate: null,
      indicatorId: null,
      pdf_file: null,
      hideEdit: null,
      formCreate: {
        name: this.checkTypeName(),
        code: '',
        date: moment().format('YYYY-MM-DD HH:mm:ss'),
        ref_id: '',
        indicator_id: '',
        indicator_ws_id: '',
        type: 1,
        pdf_url: '',
        indicator_name: ''
      },
      formUpdate: {
        name: '',
        code: '',
        date: '',
        ref_id: '',
        indicator_id: '',
        indicator_ws_id: '',
        type: 1,
        pdf_url: '',
        pdf: null,
        indicator_name: ''
      },
      formResult: {
        conclusion: '',
        description: '',
        comment: '',
        files: [],
        performer_id: null
      },
      loadingDoctor: false,
      doctors: [],
      doctorPaging: {},
      emrIndications: [],
      emrIndicationPaging: {},
      moment,
      editingInd: null,
      editingMode: 'view',
      uploadEmrIndicationFile,
      resultDocuments: {
        files: [],
        nameFiles: [],
        typeFile: 1
      },
      resultDocumentPacs: {
        files: [],
        nameFiles: [],
        typeFile: 2
      },
      removedIndicationFileIds: [],
      links: [],
      loadingList: false,
      loadingDetail: false,
      loadingPrinting: false,
      checkType: null,
      file: null,
      uploadCircleFile,
      fileInputKey: 0,
      appUtils,
      isSyncing: false,
      emrIndicationRead: {},
      tableIndicationsResult: null
    }
  },
  computed: {
    ...mapState({
      person: (state) => state.person,
      emrData: (state) => state.emrData
    }),
    uploadedLinks () {
      return (
        this.editingInd?.result?.documents?.filter((f) => f.type === 2) || []
      )
    },
    uploadedFiles () {
      return (
        this.editingInd?.result?.documents?.filter((f) => f.type === 1) || []
      )
    },
    isHasEHCSync () {
      const settings = appUtils.isJSON(this.$globalClinic?.settings)
        ? JSON.parse(this.$globalClinic?.settings)
        : {}
      return !!settings?.ehc_config
    },
    linksRes () {
      return [...this.links, ...this.uploadedLinks]
    }
  },
  watch: {
    editingInd (value) {
      if (value) {
        this.formUpdate.name = value.name
        this.formUpdate.date = value.date
        this.formUpdate.indicator_id =
          value.indicator_name || value.indicator_id
        this.formUpdate.pdf_url = value.pdf_url
      }
    },
    $refresh (r) {
      this.getEmrIndication()
      if (this.editingInd) this.viewDetail(this.editingInd)
    },
    indType (t) {
      this.formCreate.type = t
    },
    '$route.query.t' () {
      this.refresh()
      setTimeout(() => {
        this.handleMount()
      }, 100)
    }
    // tableIndicationsResult: {
    //   async handler (data) {
    //     if (data.length) {
    //       console.log(this.links, this.uploadedLinks)
    //       if (this.links?.length > 0 || this.uploadedLinks?.length > 0) {
    //         const links = [...this.links, ...this.uploadedLinks]

    //         const hasResultFile = links.some((link) => {
    //           return link?.name?.includes(`_${this.emrIndicationRead?.id}_`)
    //         })
    //         if (!hasResultFile && data.length > 0) {
    //           // await this.handlePrint()
    //         }
    //       } else {
    //         if (data?.length > 0) {
    //           // await this.handlePrint()
    //         }
    //       }
    //     }
    //   },
    //   deep: true
    // }
  },
  created () {
    this.$eventBus.$on('syncVimes', this.handleMount)
    this.$eventBus.$on('syncEHC', this.handleMount)
  },
  beforeDestroy () {
    this.$eventBus.$off('syncVimes', this.handleMount)
    this.$eventBus.$off('syncEHC', this.handleMount)
  },
  mounted () {
    let self = this
    this.handleMount()
    this.$nextTick(function () {
      window.$('#modalEmrIndicationView').on('hidden.bs.modal', function (e) {
        self.refresh()
        self.hideEdit = null
      })
      window.$('#modalEmrIndication').on('hidden.bs.modal', function (e) {
        self.refresh()
      })

      window.$('#modalEmrIndicationView').on('hide.bs.modal', function (e) {
        if (self.editingMode === 'update') {
          if (
            !confirm(
              'Các thay đổi có thể chưa được lưu. Bạn có muốn lưu không?'
            )
          ) {
            return true
          } else self.onUpdate()
        }
      })
    })
  },
  methods: {
    // getNameDoctor (value) {
    //   if (!isNaN(value)) {
    //     const item = _.find(this.doctors, { id: value })
    //     this.formCreate.indicator_name = item?.name
    //   }
    // },
    setIsLoadingDetail (value) {
      this.isLoadingDetail = value
    },
    setTableIndicationsResult (value) {
      this.tableIndicationsResult = [...value]
    },
    saveNewLink (value) {
      this.links.push(value)
    },
    checkTypeName () {
      if (this.indType === 1) {
        return 'Phiếu xét nghiệm/ CLS ' + window.moment().format('DD-MM-YYYY')
      } else {
        return (
          'Phiếu chẩn đoán hình ảnh ' + window.moment().format('DD-MM-YYYY')
        )
      }
    },
    closeUpdate () {
      this.hideEdit = null
      this.editingMode = 'view'
      this.file = null
    },
    async onUpdate () {
      try {
        this.loadingList = true
        this.formUpdate.type = this.indType
        this.formUpdate.indicator_ws_id = this.$globalClinic?.id

        if (isNaN(this.formUpdate.indicator_id)) {
          this.formUpdate.indicator_name = this.formUpdate.indicator_id
          this.formUpdate.indicator_id = null
        } else {
          this.formUpdate.indicator_name = null
        }

        if (this.file) {
          this.formUpdate.pdf_url = this.file
        } else {
          this.formUpdate.pdf_url = this.editingInd.pdf_url
        }
        const formData = new FormData()
        for (var key in this.formUpdate) {
          formData.append(key, this.formUpdate[key] || '')
        }
        await this.$rf
          .getRequest('DoctorRequest')
          .postEmrIndication(this.editingInd.id, formData)
          .then((r) => {
            this.getEmrIndication()
            if (this.editingInd) {
              this.showEmrIndication(this.editingInd.id)
            }
            this.hideEdit = null
            this.editingMode = 'view'
            this.$toast.open({
              message: 'Cập nhật thành công',
              type: 'success'
            })
          })
      } finally {
        this.loadingList = false
      }
    },
    showResult () {
      this.editingMode = 'result'
    },
    onShowPickPdf () {
      this.err_file = ''
      window.$('input[id="pdf-upload"]').trigger('click')
    },
    onSelectPdf (event) {
      this.pdf_file = event.target.files[0]
    },
    onShowPickFileUpdate () {
      this.err_file = ''
      window.$('input[id="pdf-update"]').trigger('click')
    },
    onSelectFileUpdate (event) {
      this.file = event.target.files[0]
    },
    CloseModal () {
      const fileInput = document.getElementById('pdf-upload')

      this.file = null
      this.pdf_file = null
      this.err_file = ''
      fileInput.value = ''
      this.fileInputKey++
    },
    showUpdate () {
      this.editingMode = 'update'
      this.hideEdit = 1
    },
    handleMount () {
      this.formCreate.type = this.indType || 1

      if (this.$route.query.creating) {
        this.showModal(true)
      }
      this.getEmrIndication()
      this.getDoctor()
      this.formCreate.indicator_ws_id = this.$globalClinic?.id
      let query = Object.assign({}, this.$route.query)
      if (query.viewId) {
        this.showEmrIndication(query.viewId)
        delete query.viewId
      }
      query.page = 1
      this.$router.replace({ query }).catch((_) => { })
    },
    refresh () {
      const fileInput = document.getElementById('pdf-upload')

      this.file = null
      this.pdf_file = null
      this.fileInputKey++
      if (fileInput) {
        fileInput.value = ''
      }

      this.formCreate = {
        code: '',
        date: moment().format('YYYY-MM-DD HH:mm:ss'),
        ref_id: '',
        indicator_id: '',
        indicator_ws_id: this.$globalClinic?.id
      }
      this.formResult = {
        conclusion: '',
        description: '',
        comment: '',
        files: [],
        performer_id: null
      }
      this.editingInd = null
      this.emrIndicationRead = {}
      this.editingMode = 'view'
      this.resultDocuments = {
        files: [],
        nameFiles: [],
        typeFile: 1
      }

      this.links = []
      this.getEmrIndication()
      this.getDoctor()

      if (this.indType === 1) {
        this.formCreate.name =
          'Phiếu xét nghiệm/ CLS ' + window.moment().format('DD-MM-YYYY')
        this.formCreate.type = this.indType || 1
      }

      if (this.indType === 2) {
        this.formCreate.name =
          'Phiếu chẩn đoán hình ảnh ' + window.moment().format('DD-MM-YYYY')
        this.resultDocumentPacs = {
          files: [],
          nameFiles: [],
          typeFile: 2
        }
        this.formCreate.type = this.indType || 2
      }
    },
    showModal (show) {
      window.$('#modalEmrIndication').modal(show ? 'show' : 'hide')
    },
    getDoctor (search = null) {
      if (this.$globalClinic) {
        if (this.$globalClinic?.org_id) {
          this.getOrgDoctor(search)
        } else {
          this.getClinicDoctor(search)
        }
      }
    },
    async getOrgDoctor (search = null) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getOrgDoctor(this.$globalClinic?.org_id, params)
        .then((r) => {
          this.doctors = r.data
          this.doctorPaging = r.meta
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    async getClinicDoctor (search) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getClinicDoctor(this.$globalClinic?.id, params)
        .then((r) => {
          this.doctors = r.data.data
          this.doctors.map((d) => {
            d.name = d.doctor?.name
            d.user_id = d.doctor?.user_id
          })
          this.doctorPaging = {
            count: r.data.count,
            current_page: r.data.current_page,
            last_page: r.data.last_page,
            per_page: r.data.per_page,
            total: r.data.total
          }
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    handleCurrentPage (page) {
      let query = Object.assign({}, this.$route.query)
      query.page = page
      this.$router.replace({ query }).catch((_) => { })
      this.getEmrIndication()
    },
    normalizeIndication (raw) {
      if (!raw) return raw
      return {
        ...raw,
        id: raw.id,
        name: raw.name || '',
        date: raw.ind_date || raw.created_at || null,
        indicator_name: null,
        indicator: null,
        result: null,
        indicator_w_s: raw.clinic || raw.service_provider || null,
        status: raw.status
      }
    },
    async getEmrIndication (search = null) {
      this.loadingList = true
      const params = {
        // medical_record_id: this.$route.params.id || this.emrData?.id
        // limit: 20,
        // page: this.$route.query.page || 1,
        // sort: 'date',
        // sort_by: 'desc'
      }

      if (this.indType === 1) params.is_lab = 1
      if (this.indType === 2) params.is_rad = 1

      if (search) {
        params.search = search
      }

      await this.$rf
        .getRequest('DoctorRequest')
        .getEmrIndications(this.$route.params.id, params)
        .then((r) => {
          const body = (r && r.data && r.data.data) ? r.data.data : (r && r.data ? r.data : {})

          let indications = []
          if (this.indType === 1) {
            indications = body.lab_indications || []
          } else if (this.indType === 2) {
            indications = body.rad_indications || []
          } else {
            indications = (body.lab_indications || []).concat(body.rad_indications || [])
          }

          let fullList = indications.map((ind) => {
            const base = this.normalizeIndication(ind)
            return {
              ...base,
              id: ind.id || ind.indication_id || base.id,
              name: ind.name || base.name,
              date: ind.date || ind.ind_date || base.date,
              indicator_name: ind.indicator_name || (ind.indicator && ind.indicator.name) || base.indicator_name,
              indicator: ind.indicator || base.indicator,
              result: ind.examination_result || ind.result || base.result,
              indicator_w_s: ind.clinic || ind.service_provider || base.indicator_w_s,
              status: ind.status != null ? ind.status : base.status,
              _indication: ind
            }
          })

          try {
            fullList.sort((a, b) => {
              const ta = a && a.date ? new Date(a.date).getTime() : 0
              const tb = b && b.date ? new Date(b.date).getTime() : 0
              return tb - ta
            })
          } catch (e) {
            // ignore sort errors
          }

          const per_page = 20
          const current_page = parseInt(this.$route.query.page) || 1
          const total = fullList.length
          const last_page = Math.max(1, Math.ceil(total / per_page))
          const start = (current_page - 1) * per_page
          const paged = fullList.slice(start, start + per_page)

          this.emrIndications = paged
          console.log(this.emrIndications)
          this.emrIndicationPaging = {
            total: total,
            per_page: per_page,
            current_page: current_page,
            last_page: last_page
          }
        })
        .finally(() => {
          this.loadingList = false
          this.loadingDetail = false
        })
    },
    async onUpload () {
      if (!this.formCreate.name) {
        return alert('Vui lòng nhập tên')
      }
      // if (!this.pdf_file) {
      //   return alert('Vui lòng chọn file')
      // }
      try {
        this.loadingList = true
        this.formCreate.indicator_ws_id = this.$globalClinic?.id
        this.formCreate.pdf_url = this.pdf_file

        if (isNaN(this.formCreate.indicator_id)) {
          this.formCreate.indicator_name = this.formCreate.indicator_id
          this.formCreate.indicator_id = null
        } else {
          this.formUpdate.indicator_name = null
        }

        const formData = new FormData()
        for (var key in this.formCreate) {
          formData.append(key, this.formCreate[key] || '')
        }
        await this.$rf
          .getRequest('DoctorRequest')
          .createEmrIndication(this.$route.params.id, formData)
          .then((r) => {
            this.showModal(false)
            this.getEmrIndication()
          })
      } finally {
        this.loadingList = false
      }
    },
    async onCreate () {
      this.loadingList = true

      if (isNaN(this.formCreate.indicator_id)) {
        this.formCreate.indicator_name = this.formCreate.indicator_id
        this.formCreate.indicator_id = null
      } else {
        this.formUpdate.indicator_name = null
      }

      await this.$rf
        .getRequest('DoctorRequest')
        .createEmrIndication(this.$route.params.id, this.formCreate)
        .then((r) => {
          this.showModal(false)
          this.getEmrIndication()
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    async showEmrIndication (id) {
      let item = this.emrIndications.find((x) => x.id === id || x.indication_order_id === id)
      if (!item) {
        await this.getEmrIndication()
        item = this.emrIndications.find((x) => x.id === id || x.indication_order_id === id)
      }
      if (item) return this.viewDetail(item)
      console.warn('Indication not found locally for id', id)
    },
    async viewDetail (ind) {
      this.loadingList = true
      this.editingInd = ind
      this.emrIndicationRead = null
      this.tableIndicationsResult = null
      await this.ehcSyncCoreIndication(ind?.id)

      try {
        await this.readEmrIndication(ind)
      } catch (err) {
        // ignore read errors
        console.warn(err)
      }

      if (ind.result) {
        this.editingInd.result = ind.result
      } else if (ind._indication && ind._indication.examination_result) {
        this.editingInd.result = ind._indication.examination_result
      } else if (ind.result_id || ind.result?.id) {
        const rid = ind.result?.id || ind.result_id
        if (rid) await this.getEmrIndicationResult(rid)
      }

      if (!this.editingInd.result && this.emrIndicationRead && this.emrIndicationRead.examination_result) {
        const er = this.emrIndicationRead.examination_result
        this.editingInd.result = er

        if (this.emrIndicationRead.examination_result_conclusion) {
          const conc = this.emrIndicationRead.examination_result_conclusion
          const conclusion = conc.conclusion || ''
          const description = conc.description || conc.remark || ''
          const comment = conc.doctor_conclusion_comment || ''
          const erDescription = (er && er.description) || ''
          this.formResult = {
            conclusion: conclusion,
            description: description || erDescription,
            comment: comment,
            files: [],
            performer_id: conc.review_by
          }
        }

        if (this.emrIndicationRead.indication_files && this.emrIndicationRead.indication_files.length) {
          const validFiles = (this.emrIndicationRead.indication_files || []).filter(f => {
            const hasUrl = f.URL && String(f.URL).trim().length > 0
            const hasPacs = f.PacID && Number(f.PacID) > 0
            return hasUrl || hasPacs
          })

          const mappedFiles = validFiles.map(f => ({
            id: f.id,
            type: f.Type,
            name: f.Name,
            url: f.URL,
            file_name: f.URL,
            pacs_id: f.PacID,
            created_at: f.created_at
          }))

          this.editingInd.result = this.editingInd.result || {}

          const existingDocs = this.editingInd.result.documents || []
          const existingIds = new Set(existingDocs.map(d => d.id))
          const newDocs = mappedFiles.filter(d => !existingIds.has(d.id))
          this.editingInd.result.documents = [...existingDocs, ...newDocs]

          // expose files to formResult.files for CĐHA UI
          this.formResult.files = (this.formResult.files || []).concat(newDocs.map(d => ({ id: d.id, name: d.name, url: d.url, pacs_id: d.pacs_id, created_at: d.created_at })))

          const newLinks = newDocs
            .filter(x => x.url && String(x.url).trim().length > 0)
            .map(x => ({ url: x.url, name: x.name, type: x.type }))

          this.links = [...(this.links || []), ...newLinks]
        }

        if (er.examination_result_values && er.examination_result_values.length) {
          const table = []
          er.examination_result_values.forEach((exam) => {
            const lowHigh = (Number(exam.lower) !== Number(exam.upper))
              ? (!isNaN(Number(exam.value))
                ? (Number(exam.value) > Number(exam.upper) ? 'H' : Number(exam.value) < Number(exam.lower) ? 'L' : '')
                : '')
              : ''

            table.push({
              test_name: exam.name,
              result: exam.value || '-',
              low_high: lowHigh,
              unit: exam.unit || '-',
              normal_rate: (Number(exam.lower) !== Number(exam.upper)) ? `${exam.lower} - ${exam.upper}` : '-',
              test_machine: er.device || exam.device || '-',
              note: exam.note || '',
              is_alert: lowHigh !== ''
            })
          })
          this.tableIndicationsResult = table
        }
      }

      let hasDoctor = this.doctors.find((d) => d.id === ind.indicator_id)
      if (!hasDoctor && ind.indicator) this.doctors.unshift(ind.indicator)
      this.showModalView(true)
      // if (ind.code) {
      //   try {
      //     setTimeout(() => {
      //       JsBarcode('#viewDetailBarcode', ind.code, {
      //         displayValue: false
      //       })
      //     }, 200)
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
    },
    async getEmrIndicationResult (id) {
      this.loadingDetail = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getEmrIndicationResultV2(id)
        .then((r) => {
          const result = r.data
          let hasDoctor = this.doctors.find(
            (d) => d.id === result.performer_id
          )
          if (!hasDoctor && result.performer) {
            this.doctors.unshift(result.performer)
          }
          const conc = result.examination_result_conclusion || null
          const ketqua = (conc && conc.conclusion) || result.conclusion || ''
          const mota = (conc && conc.description) || result.description || ''
          const nhanxet = (conc && conc.doctor_conclusion_comment) || result.doctor_conclusion_comment || ''

          const mappedFiles = (result.indication_files || []).filter(f => {
            const hasUrl = f.URL && String(f.URL).trim().length > 0
            const hasPacs = f.PacID && Number(f.PacID) > 0
            return hasUrl || hasPacs
          }).map(f => ({ id: f.id, name: f.Name || f.FileName || 'file', url: f.URL, pacs_id: f.PacID, created_at: f.created_at }))

          this.formResult = {
            conclusion: ketqua,
            description: mota,
            comment: nhanxet,
            files: mappedFiles,
            performer_id: result.performer_id || result?.performer_name
          }
          this.editingInd.result = result
        })
        .finally(() => {
          this.loadingDetail = false
        })
    },
    async createEmrIndicationResult () {
      if (!this.hasEHCConnect && !this.hasVimesSync && !this.formResult.conclusion) {
        alert('Vui lòng nhập nhận xét')
        return
      }
      try {
        this.loadingDetail = true

        if (isNaN(this.formResult.performer_id)) {
          this.formResult.performer_name = this.formResult.performer_id
          this.formResult.performer_id = null
        } else {
          this.formUpdate.indicator_name = null
        }

        const hasLocalFiles = this.resultDocuments?.files?.length > 0
        const hasLinks = this.links && this.links.length > 0

        const cleanComment = DOMPurify.sanitize(this.formResult.comment || '')

        const fd = new FormData()
        fd.append('indication_id', this.editingInd.id)
        fd.append('doctor_conclusion_comment', cleanComment)

        if (hasLocalFiles || hasLinks) {
          let idx = 0
          if (hasLinks) {
            this.links.forEach((l) => {
              fd.append(`upload_files[${idx}][file_name]`, l.name || '')
              fd.append(`upload_files[${idx}][url]`, l.url || '')
              fd.append(`upload_files[${idx}][type]`, 2)
              idx++
            })
          }

          if (hasLocalFiles) {
            this.resultDocuments.files.forEach((f, i) => {
              fd.append(`upload_files[${idx}][file]`, f)
              const desc = (this.resultDocuments.nameFiles && this.resultDocuments.nameFiles[i] && this.resultDocuments.nameFiles[i].description) || f.name
              fd.append(`upload_files[${idx}][file_name]`, desc)
              fd.append(`upload_files[${idx}][type]`, 1)
              idx++
            })
          }

          if (this.removedIndicationFileIds && this.removedIndicationFileIds.length) {
            this.removedIndicationFileIds.forEach((id) => {
              fd.append('remove_indication_file_ids', id)
            })
          }
        }

        await this.$rf
          .getRequest('DoctorRequest')
          .createEmrIndicationResultV2(fd)
          .then(async (r) => {
            await this.getEmrIndication()
            await this.getEmrIndicationResult(r.data.examination_result.indication_id)
            this.editingMode = 'view'
          })
          .finally(() => {
            this.loadingDetail = false
          })
      } catch (error) {
        console.log(error)
      }
    },
    showModalView (show) {
      window.$('#modalEmrIndicationView').modal(show ? 'show' : 'hide')
      this.loadingList = false
    },
    modalUploadResultFile (show) {
      window.$('#modalUploadResultFile').modal(show ? 'show' : 'hide')
    },
    modalUploadResultLink (show) {
      window.$('#modalUploadResultLink').modal(show ? 'show' : 'hide')
    },
    // submitFile (files) {
    //   this.resultDocuments = files
    // },
    deleteLink (index) {
      if (!confirm('Bạn có chắc chắn thực hiện thao tác này?')) return
      this.links.splice(index, 1)
    },
    addLink (link) {
      this.links.push(link)
    },

    async onUploadPac (emr_indication_result_id, file, type) {
      const self = this
      self.loadingDetail = true
      const params = {
        name: file.name
      }
      await self.$rf
        .getRequest('DoctorRequest')
        .createPacs(params)
        .then((r) => {
          window.$uploadPacsFile(r.data, file, type, emr_indication_result_id)
        })
    },

    async onSubmitFiles (id) {
      if (
        !this.resultDocuments?.files?.length &&
        !this.resultDocumentPacs?.files?.length
      ) {
        return
      }

      try {
        this.loadingDetail = true

        if (this.resultDocuments.files.length) {
          await uploadFileWithTenant
            .fileUploadHandler({
              files: this.resultDocuments.files,
              path: 'resources/indications'
            })
            .then(async (res) => {
              // eslint-disable-next-line no-unused-expressions
              await Promise.all(
                res?.map((fileUrl, index) => {
                  if (!fileUrl) return

                  return {
                    emr_indication_result_id: id,
                    type: this.resultDocuments.nameFiles[index]?.typeFile || 1,
                    name:
                      this.resultDocuments.nameFiles[index]?.description ||
                      this.resultDocuments.files[index]?.name ||
                      '',
                    file_name: fileUrl
                  }
                })
              ).then(async (files) => {
                await this.$rf
                  .getRequest('DoctorRequest')
                  .postEmrIndicationResultFile(id, { files: files })
                  .then((r) => {
                    this.links = []
                    this.getEmrIndicationResult(id)
                    return r.data
                  })
                  .catch((error) => {
                    console.log('error', error)
                  })
              })
            })
            .finally(() => {
              this.resultDocuments = {
                files: [],
                nameFiles: []
              }
            })
        }

        if (this.resultDocumentPacs.files.length) {
          await Promise.all(
            this.resultDocumentPacs.files?.map(async (file) => {
              await this.onUploadPac(id, file, 1)
            })
          ).then(() => {
            this.resultDocumentPacs = {
              files: [],
              nameFiles: []
            }
          })
        }
      } catch (error) {
        console.log(error)
        this.loadingDetail = false
      }
    },
    async postEmrIndicationResultFile (id) {
      let files = []
      if (this.links?.length) {
        this.links.forEach((l) => {
          files.push({
            url: l.url,
            name: l.name,
            type: 2
          })
        })
      } else {
        return
      }
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .postEmrIndicationResultFile(id, { files: files })
        .then((r) => {
          // prototype.$emit('refresh')
          this.links = []
          this.getEmrIndicationResult(id)
          return r.data
        })
        .catch((error) => {
          console.log('error', error)
        })
      return r
    },
    async downloadFile (name) {
      if (!name) return
      const self = this
      const params = {
        fileName: name
      }
      const header = {
        'x-api-key': '4be5160e89e681cede9a80ae6db6af7c'
      }
      await self.$rf
        .getRequest('AuthRequest')
        .getLinkDownloadAwsRc(params, header, false)
        .then((r) => {
          if (r?.data?.data) window.open(r.data.data)
        })
        .catch((e) => {
          self.$toast.open({
            message:
              'File không tồn tại hoặc gặp lỗi trong quá trình tải xuống',
            type: 'warning'
          })
          console.error(e)
        })
    },
    openUrl (url) {
      if (!url) return
      window.open(url, '_blank', 'noreferrer')
    },
    uploadDocs () {
      if (this.resultDocuments?.files?.length) {
        if (
          !confirm(
            'Xác nhận, ' +
            this.resultDocuments?.files?.length +
            ' files đã chọn sẽ cần phải chọn lại'
          )
        ) {
          return
        } else {
          this.resultDocuments = {
            files: [],
            nameFiles: []
          }
        }
      }
      this.$refs.inputFileEmrIndicationList.click()
      this.$refs.inputFileEmrIndicationList.value = null
    },
    uploadPacs () {
      if (this.resultDocumentPacs?.files?.length) {
        if (
          !confirm(
            'Xác nhận, ' +
            this.resultDocumentPacs?.files?.length +
            ' files pacs đã chọn sẽ cần phải chọn lại'
          )
        ) {
          return
        } else {
          this.resultDocumentPacs = {
            files: [],
            nameFiles: []
          }
        }
      }
      this.$refs.inputFilePacsEmrIndicationList.click()
      this.$refs.inputFilePacsEmrIndicationList.value = null
    },
    onSelectedFile (e) {
      const files = e.target.files
      if (files) {
        for (let i = 0; i < files.length; i++) {
          this.resultDocuments.nameFiles.push({
            description: files[i].name,
            typeFile: 1
          })
          this.resultDocuments.files.push(files[i])
        }
        this.$refs.inputFileEmrIndicationList.value = null
      }
    },
    onSelectedFilePacs (e) {
      const files = e.target.files
      if (files) {
        for (let i = 0; i < files.length; i++) {
          this.resultDocumentPacs.nameFiles.push({
            description: files[i].name,
            typeFile: 2
          })
          this.resultDocumentPacs.files.push(files[i])
        }
        this.$refs.inputFilePacsEmrIndicationList.value = null
      }
    },
    async readEmrIndication (item) {
      if (item.subscribed?.read_at) return
      try {
        const res = await this.$rf
          .getRequest('DoctorRequest')
          .getEmrIndicationResultV2(item.id)

        if (!res?.data) return

        this.emrIndicationRead = res?.data
        return res?.data
      } catch (error) {
        console.log(error)
      }
    },
    async ehcSyncCoreIndication (id) {
      if (!id || !this.isHasEHCSync) return
      try {
        await this.$rf
          .getRequest('EHCSyncRequest')
          .ehcSyncCoreIndicationMedicalRecordById(id)
      } catch (error) {
        console.log(error)
      }
    },
    async subscribe (item) {
      let status = item.subscribed ? 0 : 1
      this.loadingList = true
      await this.$rf
        .getRequest('DoctorRequest')
        .subscribeEmrIndication(item.id, { status: status })
        .then((r) => {
          this.showModal(false)
          this.getEmrIndication()
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    getFilename (fullPath) {
      if (!_.isString(fullPath)) return
      return fullPath.split('/').pop()
    },
    openPacs (p) {
      if (p && p.status === 1) alert('Tài liệu đang trong quá trình xử lý')
      if (p && p.status === 2 && p.accession) this.getUrl(p.accession)
      if (p && p.status === 3) alert('Tài liệu bị lỗi')
    },
    async getUrl (accession) {
      const self = this
      const params = {
        accession: accession
      }
      await self.$rf
        .getRequest('DoctorRequest')
        .getUrlPac(params)
        .then((r) => {
          if (r.data) {
            window.open(r.data)
          }
        })
    },
    handleOpenPacs () {
      window.open(
        `http://k2-synapse-srv/explore.asp?path=/All%20Patients/InternalPatientUID=${this.emrData?.ref_id}`,
        '_blank'
      )
    },
    async handleSyncEHC () {
      const self = this
      try {
        self.isSyncing = true
        const params = {
          org_id: self.$globalClinic?.org_id,
          ws_id: self.$globalClinic?.id,
          patient_id: Number(self.emrData?.person?.ehc_ref_id),
          medical_record_ref_id: Number(self.emrData?.ref_id),
          emr_id: Number(self.emrData?.id)
        }
        await self.$rf
          .getRequest('EHCSyncRequest')
          .ehcSyncIndication(params)
          .then((res) => {
            if (!res?.data) return
            if (res?.data?.code === 401) {
              self.$message({
                type: 'error',
                message: self.$t(`Bạn không thể đồng bộ dữ liệu từ EHC`)
              })
              console.log(res)
              return
            }
            // console.log(res?.data)
            self.handleMount()
            self.$message({
              type: 'success',
              message: self.$t(`Đồng bộ dữ liệu thành công`)
            })
            self.isSyncing = false
          })
      } catch (error) {
        console.log(error.response)
        self.$message({
          type: 'error',
          message: self.$t(`Đã có lỗi xảy ra, không thể đồng bộ dữ liệu`)
        })
      } finally {
        self.isSyncing = false
      }
    },
    async savePdfToS3 (base64) {
      if (!base64) return

      try {
        const date = window
          .moment(this.emrIndicationRead?.date)
          .format('HHmmssDDMMYYYY')
        const payload = {
          content: base64,
          fileName: `${appUtils.convertSlug(
            `${this.$t('Kết quả xét nghiệm')}`
          )}_${this.emrIndicationRead?.id}_`,
          path: `xncls/${this.emrIndicationRead?.id}_${date || 'unknown'}`,
          type: 'print_form',
          type_id: 'print_form_id',
          uuid: ''
        }

        const res = await this.$rf
          .getRequest('DoctorRequest')
          .printDocument(payload)

        if (res?.data) {
          this.links.push({
            name: `${date}_${this.emrIndicationRead?.id
            }_KQXN_${appUtils.convertSlug(this.emrIndicationRead?.name)}`,
            url: res.data?.documentLink
          })
          // window.open(res.data?.documentLink, '_blank', 'noreferrer')
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handlePrint () {
      try {
        this.loadingList = true
        this.loadingDetail = true
        this.loadingPrinting = true
        const tempHTML = appUtils.templateHTMLPrint({
          title: document.title,
          bodyHTML: this.$refs.testResultForm.$el.innerHTML,
          appendStyle: true
        })
        const base64Data = appUtils.base64.decode(tempHTML)
        await this.savePdfToS3(base64Data)

        // await this.getEmrIndication()
        await this.getEmrIndicationResult(this.editingInd?.result?.id)
        // await this.onSubmitFiles(this.editingInd?.result?.id)
        await this.postEmrIndicationResultFile(this.editingInd?.result?.id)
        // this.refresh()
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingList = false
        this.loadingDetail = false
        this.loadingPrinting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .editor-input {
    .ql-editor {
      min-height: 200px;
      color: black;
    }
  }

  .ind-list-item:hover {
    background: #dee1eb;
  }

  .border-bottom {
    border-width: 2px;
  }

  .el-input__inner,
  input {
    background-color: #fff !important;
    border-radius: 5px !important;
    border: 1px solid rgba(101, 109, 119, 0.16) !important;
  }

  th {
    border: none !important;
  }

  .bg-EAEDF6 {
    background-color: #eaedf6;
  }

  .view-label {
    font-size: 14px;
    width: 10rem;
  }

  .modal-xxl {
    width: 100vw;
    max-width: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .h-50px {
    height: 50px;
  }

  #modalUploadResultFile {
    z-index: 2023;
  }

  .btn-upload-file {
    border: dashed 1px #20409b;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    margin-right: 16px;
  }

  .file-item {
    display: flex;
    width: 100%;
    align-items: center;
    cursor: pointer;
    height: 50px;
    margin-right: 16px;
  }

  .disabled {
    cursor: not-allowed !important;
    opacity: 0.2 !important;
  }

  .link-item {
    width: 100%;
    max-width: 350px;
    cursor: pointer;
  }

  .v-html p {
    margin-bottom: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .v-html {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media only screen and (max-width: 600px) {
    .v-html {
      width: 100%;
    }
  }

  .modal-content {
    max-height: 96vh;
    overflow: auto;
  }

  .unread td,
  .unread td dev {
    font-weight: bold;
  }

  .handleLoading {
    z-index: 0;
  }
}
</style>
